import React from 'react'
import PropTypes from 'prop-types'
import currencyUtils from 'utils/currency'
import { Eyebrow } from 'components/Typography'
import getProductPricingItems from 'utils/productPricingUtil'
import theme from 'styles/theme'
import styled from 'styled-components'

import {
  ProductCardList,
  ProductCardListItem,
  ProductCardListItemWrapper,
} from './ProductCardPriceInfo.style'

const PriceLabelEyebrow = styled(Eyebrow)`
  min-width: ${(props) => props.minWidth};
`

const PriceEyebrow = styled(Eyebrow)`
  ${theme.mediaQueries.xlarge} {
    word-break: break-all;
  }
`

const ProductCardPriceInfo = ({
  currency,
  rrpPrice,
  salePrice,
  villagePrice,
  labels,
  enablePriceLabelMinWidth,
}) => {
  const pricingItems = getProductPricingItems({
    rrpPrice,
    villagePrice,
    salePrice,
    labels,
  })

  let priceLabelMinWidth

  return (
    <>
      {currency && pricingItems && (
        <ProductCardList>
          {pricingItems.map(({ price, strikethrough, label }, index) => {
            if (enablePriceLabelMinWidth) {
              priceLabelMinWidth = label.length > 12 ? '95px' : '75px'
            }

            return (
              <ProductCardListItemWrapper>
                <ProductCardListItem
                  strikethrough={false}
                  faded={strikethrough}
                  // eslint-disable-next-line react/no-array-index-key
                  key={`product-pricing-${index}`}>
                  <PriceLabelEyebrow mb={[0]} minWidth={priceLabelMinWidth}>
                    {label}
                  </PriceLabelEyebrow>
                </ProductCardListItem>
                <ProductCardListItem
                  strikethrough={strikethrough}
                  faded={strikethrough}
                  // eslint-disable-next-line react/no-array-index-key
                  key={`product-pricing-${index}-strikethrough`}>
                  <PriceEyebrow mb={[0]}>
                    {currencyUtils[currency](price, { simple: true })}
                  </PriceEyebrow>
                </ProductCardListItem>
              </ProductCardListItemWrapper>
            )
          })}
        </ProductCardList>
      )}
    </>
  )
}

ProductCardPriceInfo.propTypes = {
  currency: PropTypes.string,
  rrpPrice: PropTypes.number,
  salePrice: PropTypes.number,
  villagePrice: PropTypes.number,
  labels: PropTypes.shape({}),
  enablePriceLabelMinWidth: PropTypes.bool,
}

ProductCardPriceInfo.defaultProps = {
  salePrice: null,
  currency: null,
  rrpPrice: null,
  villagePrice: null,
  labels: {},
  enablePriceLabelMinWidth: false,
}

export default ProductCardPriceInfo
